<template>
  <div class="download-page">
    <div v-if="isGlobalOverlayVisible" class="global-blocking-overlay" aria-live="polite" aria-busy="true">
      <div class="global-blocking-overlay__content">
        <i class="el-icon-loading" />
        <span>{{ downloading ? 'Téléchargement en cours...' : 'Comptage en cours...' }}</span>
      </div>
    </div>
    <el-card class="download-card" shadow="hover">
      <el-tabs v-model="activeTab" tab-position="left" class="download-tabs" @tab-click="handleTabClick">
        <el-tab-pane label="Export multi-types" name="multi">
          <div v-if="loading" class="download-tab-spinner">
            <div class="download-tab-spinner__oval"><i class="el-icon-loading" /><span>Chargement des données...</span></div>
          </div>
          <div v-else class="download-pane">
            <div class="download-pane__header">
              <h2 class="download-pane__title">Export multi-types</h2>
            </div>
            <div class="download-pane__filters">
              <span class="download-pane__filters-label">Types de fiches</span>
              <el-checkbox-group v-model="multiTypes">
                <el-checkbox v-for="item in availableMultiTypes" :key="item.value" :label="item.value">{{ item.label }}</el-checkbox>
              </el-checkbox-group>
              <span class="download-pane__filters-label">Filtres communs</span>
              <el-form :inline="true" :model="filters.multi" class="download-form">
                <el-form-item label="Campagne agricole">
                  <el-select v-model="filters.multi.campagne" placeholder="Sélectionner" filterable>
                    <el-option v-for="item in campagnes_agricoles" :key="item.id" :label="item.periode" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Région"><el-select v-model="filters.multi.region" placeholder="Sélectionner" filterable clearable><el-option v-for="item in regions" :key="item.id" :label="item.nom" :value="item.id" /></el-select></el-form-item>
                <el-form-item label="Zone"><el-select v-model="filters.multi.zone" placeholder="Sélectionner" filterable clearable><el-option v-for="item in zones" :key="item.id" :label="item.nom" :value="item.id" /></el-select></el-form-item>
                <el-form-item label="Commune"><el-select v-model="filters.multi.commune" placeholder="Sélectionner" filterable clearable><el-option v-for="item in communes" :key="item.id" :label="item.nom" :value="item.id" /></el-select></el-form-item>
                <el-form-item label="Village"><el-select v-model="filters.multi.village" placeholder="Sélectionner" filterable clearable><el-option v-for="item in villages" :key="item.id" :label="item.nom" :value="item.id" :disabled="!item.is_active" /></el-select></el-form-item>
                <el-form-item label="Unité de production"><el-select v-model="filters.multi.unite_production" placeholder="Sélectionner" filterable><el-option v-for="item in unite_productions" :key="item.id" :label="item.nom" :value="item.id" /></el-select></el-form-item>
                <el-form-item label="Groupement"><el-select v-model="filters.multi.groupement" placeholder="Sélectionner" filterable><el-option v-for="item in groupements" :key="item.id" :label="uppercaseFirst(item.nom)" :value="item.id" :disabled="!item.is_active" /></el-select></el-form-item>
                <el-form-item label="Producteur"><el-select v-model="filters.multi.producteur" placeholder="Sélectionner" filterable><el-option v-for="item in producteurs" :key="item.id" :label="uppercaseFirst(item.nom)" :value="item.id" /></el-select></el-form-item>
                <el-form-item label="Contrôleur"><el-select v-model="filters.multi.controleur" placeholder="Sélectionner" filterable><el-option v-for="item in controleurs" :key="item.id" :label="uppercaseFirst(item.nom)" :value="item.id" /></el-select></el-form-item>
                <el-form-item label="Certification"><el-input v-model="filters.multi.certification" placeholder="Ex: BIO, RA..." clearable /></el-form-item>
                <el-form-item label="Période"><el-date-picker v-model="filters.multi.dateRange" type="daterange" range-separator="à" start-placeholder="Date début" end-placeholder="Date fin" format="dd/MM/yyyy" /></el-form-item>
              </el-form>
            </div>
            <div class="download-pane__result">
              <div class="download-count-block" :class="{ 'download-count-block--loading': loadingCountMulti }">
                <template v-if="loadingCountMulti">
                  <div class="download-count-loading-oval"><i class="el-icon-loading" /><span class="count-text">Comptage en cours...</span></div>
                </template>
                <template v-else-if="multiCountInfo">
                  <div class="download-count-badge download-count-badge--ok"><i class="el-icon-data-analysis" /><span>Total: {{ multiCountInfo.total_count }} document(s)</span></div>
                  <div class="download-multi-details">
                    <span v-for="item in multiCountInfo.by_type" :key="item.type" class="download-multi-details__item">{{ item.type }}: {{ item.count }}</span>
                  </div>
                </template>
              </div>
            </div>
            <div class="download-pane__actions">
              <el-button type="primary" size="medium" icon="el-icon-message" :loading="downloadingMulti" :disabled="!filters.multi.campagne || multiTypes.length === 0" @click="exportMultiBackground">Préparer et envoyer par email</el-button>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('fiches.ficheEngagement')" name="contrats">
          <div v-if="loading" class="download-tab-spinner">
            <div class="download-tab-spinner__oval">
              <i class="el-icon-loading" />
              <span>Chargement des données...</span>
            </div>
          </div>
          <div v-else class="download-pane">
            <div class="download-pane__header">
              <h2 class="download-pane__title">{{ $t('fiches.fichesEngagement') }}</h2>
              <el-button type="text" size="small" icon="el-icon-refresh-left" @click="initSearch">Réinitialiser</el-button>
            </div>
            <div class="download-pane__filters">
              <span class="download-pane__filters-label">Filtres</span>
              <div class="download-count-block download-count-block--top" :class="{ 'download-count-block--loading': loadingCount.contrats }">
                <template v-if="loadingCount.contrats">
                  <div class="download-count-loading-oval">
                    <i class="el-icon-loading" />
                    <span class="count-text">Comptage en cours...</span>
                  </div>
                </template>
                <template v-else-if="countInfo.contrats !== undefined && countInfo.contrats !== null">
                  <div class="download-count-badge download-count-badge--ok">
                    <i class="el-icon-data-analysis" />
                    <span>Résultat du comptage : {{ countInfo.contrats.count }} {{ countInfo.contrats.type_label }}</span>
                  </div>
                </template>
                <template v-else>
                  <div class="download-count-badge download-count-badge--zero">
                    <i class="el-icon-info" />
                    <span>Comptage indisponible pour le moment. Ajustez un filtre pour relancer le comptage.</span>
                  </div>
                </template>
              </div>
              <el-form :inline="true" :model="filters.contrats" class="download-form">
                <el-form-item label="Campagne agricole">
                  <el-select v-model="filters.contrats.campagne" placeholder="Sélectionner" filterable>
                    <el-option v-for="item in campagnes_agricoles" :key="item.id" :label="item.periode" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Scoop">
                  <el-select v-model="filters.contrats.scoop" placeholder="Sélectionner" filterable clearable>
                    <el-option v-for="item in scoops" :key="item.id" :label="item.nom" :value="item.id" />
                  </el-select>
                </el-form-item>
                <!-- Sélections hiérarchiques des localités -->
                <el-form-item label="Région">
                  <el-select v-model="filters.contrats.region" placeholder="Sélectionner" filterable clearable @change="onRegionChange('contrats')">
                    <el-option v-for="item in regions" :key="item.id" :label="item.nom" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Zone">
                  <el-select v-model="filters.contrats.zone" placeholder="Sélectionner" filterable clearable @change="onZoneChange('contrats')">
                    <el-option v-for="item in zones" :key="item.id" :label="item.nom" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Commune">
                  <el-select v-model="filters.contrats.commune" placeholder="Sélectionner" filterable clearable @change="onCommuneChange('contrats')">
                    <el-option v-for="item in communes" :key="item.id" :label="item.nom" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Village">
                  <el-select v-model="filters.contrats.village" placeholder="Sélectionner" filterable clearable @change="onVillageChange('contrats')">
                    <el-option v-for="item in villages" :key="item.id" :label="item.nom" :value="item.id" :disabled="!item.is_active" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Unité de production">
                  <el-select v-model="filters.contrats.unite_production" placeholder="Sélectionner" filterable @change="getUPGroupementsList('contrats')">
                    <el-option v-for="item in unite_productions" :key="item.id" :label="item.nom" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Groupement">
                  <el-select v-model="filters.contrats.groupement" v-waves class="filter-item" placeholder="Sélectionner" filterable>
                    <el-option v-for="item in groupements" :key="item.id" :label="uppercaseFirst(item.nom)" :value="item.id" :disabled="!item.is_active" />
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            <div class="download-pane__actions">
              <el-button type="primary" size="medium" icon="el-icon-download" :loading="downloading" :disabled="isDownloadDisabled('contrats')" @click="download('contrats')">
                Télécharger le ZIP
              </el-button>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="Fiches de formation" name="formation">
          <div v-if="loading" class="download-tab-spinner">
            <div class="download-tab-spinner__oval"><i class="el-icon-loading" /><span>Chargement des données...</span></div>
          </div>
          <div v-else class="download-pane">
            <div class="download-pane__header">
              <h2 class="download-pane__title">{{ $t('fiches.fichesFormation') }}</h2>
              <el-button type="text" size="small" icon="el-icon-refresh-left" @click="initSearch">Réinitialiser</el-button>
            </div>
            <div class="download-pane__filters">
              <span class="download-pane__filters-label">Filtres</span>
              <div class="download-count-block download-count-block--top" :class="{ 'download-count-block--loading': loadingCount.formations }">
                <template v-if="loadingCount.formations">
                  <div class="download-count-loading-oval">
                    <i class="el-icon-loading" />
                    <span class="count-text">Comptage en cours...</span>
                  </div>
                </template>
                <template v-else-if="countInfo.formations !== undefined && countInfo.formations !== null">
                  <div class="download-count-badge download-count-badge--ok">
                    <i class="el-icon-data-analysis" />
                    <span>Résultat du comptage : {{ countInfo.formations.count }} {{ countInfo.formations.type_label }}</span>
                  </div>
                </template>
                <template v-else>
                  <div class="download-count-badge download-count-badge--zero">
                    <i class="el-icon-info" />
                    <span>Comptage indisponible pour le moment. Ajustez un filtre pour relancer le comptage.</span>
                  </div>
                </template>
              </div>
              <el-form :inline="true" :model="filters.formations" class="download-form">
                <el-form-item label="Campagne agricole">
                  <el-select v-model="filters.formations.campagne" placeholder="Sélectionner" filterable>
                    <el-option v-for="item in campagnes_agricoles" :key="item.id" :label="item.periode" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Controleur">
                  <el-select v-model="filters.formations.controleur" class="filter-item" placeholder="Sélectionner" filterable>
                    <el-option v-for="(cont, index) in controleurs" :key="index" :label="uppercaseFirst(cont.nom)" :value="cont.id" :disabled="!cont.is_active" />
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            <div class="download-pane__actions">
              <el-button type="primary" size="medium" icon="el-icon-download" :loading="downloading" :disabled="isDownloadDisabled('formations')" @click="download('formations')">Télécharger le ZIP</el-button>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="Fiches de contrôle interne" name="controle_interne">
          <div v-if="loading" class="download-tab-spinner">
            <div class="download-tab-spinner__oval"><i class="el-icon-loading" /><span>Chargement des données...</span></div>
          </div>
          <div v-else class="download-pane">
            <div class="download-pane__header">
              <h2 class="download-pane__title">{{ $t('fiches.fichesControlleInterne') }}</h2>
              <el-button type="text" size="small" icon="el-icon-refresh-left" @click="initSearch">Réinitialiser</el-button>
            </div>
            <div class="download-pane__filters">
              <span class="download-pane__filters-label">Filtres</span>
              <div class="download-count-block download-count-block--top" :class="{ 'download-count-block--loading': loadingCount.controle_interne }">
                <template v-if="loadingCount.controle_interne">
                  <div class="download-count-loading-oval">
                    <i class="el-icon-loading" />
                    <span class="count-text">Comptage en cours...</span>
                  </div>
                </template>
                <template v-else-if="countInfo.controle_interne !== undefined && countInfo.controle_interne !== null">
                  <div class="download-count-badge download-count-badge--ok">
                    <i class="el-icon-data-analysis" />
                    <span>Résultat du comptage : {{ countInfo.controle_interne.count }} {{ countInfo.controle_interne.type_label }}</span>
                  </div>
                </template>
                <template v-else>
                  <div class="download-count-badge download-count-badge--zero">
                    <i class="el-icon-info" />
                    <span>Comptage indisponible pour le moment. Ajustez un filtre pour relancer le comptage.</span>
                  </div>
                </template>
              </div>
              <el-form :inline="true" :model="filters.controle_interne" class="download-form">
                <el-form-item label="Campagne agricole">
                  <el-select v-model="filters.controle_interne.campagne" placeholder="Sélectionner" filterable>
                    <el-option v-for="item in campagnes_agricoles" :key="item.id" :label="item.periode" :value="item.id" />
                  </el-select>
                </el-form-item>
                <!-- Sélections hiérarchiques des localités -->
                <el-form-item label="Région">
                  <el-select v-model="filters.controle_interne.region" placeholder="Sélectionner" filterable clearable @change="onRegionChange('controle_interne')">
                    <el-option v-for="item in regions" :key="item.id" :label="item.nom" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Zone">
                  <el-select v-model="filters.controle_interne.zone" placeholder="Sélectionner" filterable clearable @change="onZoneChange('controle_interne')">
                    <el-option v-for="item in zones" :key="item.id" :label="item.nom" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Commune">
                  <el-select v-model="filters.controle_interne.commune" placeholder="Sélectionner" filterable clearable @change="onCommuneChange('controle_interne')">
                    <el-option v-for="item in communes" :key="item.id" :label="item.nom" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Village">
                  <el-select v-model="filters.controle_interne.village" placeholder="Sélectionner" filterable clearable @change="onVillageChange('controle_interne')">
                    <el-option v-for="item in villages" :key="item.id" :label="item.nom" :value="item.id" :disabled="!item.is_active" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Unité de production">
                  <el-select v-model="filters.controle_interne.unite_production" placeholder="Sélectionner" filterable @change="getUPGroupementsList('controle_interne')">
                    <el-option v-for="item in unite_productions" :key="item.id" :label="item.nom" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Groupement">
                  <el-select v-model="filters.controle_interne.groupement" v-waves class="filter-item" placeholder="Sélectionner" filterable @change="getGroupProducteursList('controle_interne')">
                    <el-option v-for="item in groupements" :key="item.id" :label="uppercaseFirst(item.nom)" :value="item.id" :disabled="!item.is_active" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Producteur">
                  <el-select v-model="filters.controle_interne.producteur" v-waves class="filter-item" placeholder="Sélectionner" filterable>
                    <el-option v-for="item in producteurs" :key="item.id" :label="uppercaseFirst(item.nom)" :value="item.id" :disabled="!item.is_active" />
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            <div class="download-pane__actions">
              <el-button type="primary" size="medium" icon="el-icon-download" :loading="downloading" :disabled="isDownloadDisabled('controle_interne')" @click="download('controle_interne')">Télécharger le ZIP</el-button>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="Fiches parcellaire" name="parcellaire">
          <div v-if="loading" class="download-tab-spinner">
            <div class="download-tab-spinner__oval"><i class="el-icon-loading" /><span>Chargement des données...</span></div>
          </div>
          <div v-else class="download-pane">
            <div class="download-pane__header">
              <h2 class="download-pane__title">{{ $t('fiches.fichesParcellaire') }}</h2>
              <el-button type="text" size="small" icon="el-icon-refresh-left" @click="initSearch">Réinitialiser</el-button>
            </div>
            <div class="download-pane__filters">
              <span class="download-pane__filters-label">Filtres</span>
              <div class="download-count-block download-count-block--top" :class="{ 'download-count-block--loading': loadingCount.parcellaire }">
                <template v-if="loadingCount.parcellaire">
                  <div class="download-count-loading-oval">
                    <i class="el-icon-loading" />
                    <span class="count-text">Comptage en cours...</span>
                  </div>
                </template>
                <template v-else-if="countInfo.parcellaire !== undefined && countInfo.parcellaire !== null">
                  <div class="download-count-badge download-count-badge--ok">
                    <i class="el-icon-data-analysis" />
                    <span>Résultat du comptage : {{ countInfo.parcellaire.count }} {{ countInfo.parcellaire.type_label }}</span>
                  </div>
                </template>
                <template v-else>
                  <div class="download-count-badge download-count-badge--zero">
                    <i class="el-icon-info" />
                    <span>Comptage indisponible pour le moment. Ajustez un filtre pour relancer le comptage.</span>
                  </div>
                </template>
              </div>
              <el-form :inline="true" :model="filters.parcellaire" class="download-form">
                <el-form-item label="Campagne agricole">
                  <el-select v-model="filters.parcellaire.campagne" placeholder="Sélectionner" filterable>
                    <el-option v-for="item in campagnes_agricoles" :key="item.id" :label="item.periode" :value="item.id" />
                  </el-select>
                </el-form-item>
                <!-- Sélections hiérarchiques des localités -->
                <el-form-item label="Région">
                  <el-select v-model="filters.parcellaire.region" placeholder="Sélectionner" filterable clearable @change="onRegionChange('parcellaire')">
                    <el-option v-for="item in regions" :key="item.id" :label="item.nom" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Zone">
                  <el-select v-model="filters.parcellaire.zone" placeholder="Sélectionner" filterable clearable @change="onZoneChange('parcellaire')">
                    <el-option v-for="item in zones" :key="item.id" :label="item.nom" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Commune">
                  <el-select v-model="filters.parcellaire.commune" placeholder="Sélectionner" filterable clearable @change="onCommuneChange('parcellaire')">
                    <el-option v-for="item in communes" :key="item.id" :label="item.nom" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Village">
                  <el-select v-model="filters.parcellaire.village" placeholder="Sélectionner" filterable clearable @change="onVillageChange('parcellaire')">
                    <el-option v-for="item in villages" :key="item.id" :label="item.nom" :value="item.id" :disabled="!item.is_active" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Unité de production">
                  <el-select v-model="filters.parcellaire.unite_production" placeholder="Sélectionner" filterable @change="getUPGroupementsList('parcellaire')">
                    <el-option v-for="item in unite_productions" :key="item.id" :label="item.nom" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Groupement">
                  <el-select v-model="filters.parcellaire.groupement" v-waves class="filter-item" placeholder="Sélectionner" filterable @change="getGroupProducteursList('parcellaire')">
                    <el-option v-for="item in groupements" :key="item.id" :label="uppercaseFirst(item.nom)" :value="item.id" :disabled="!item.is_active" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Producteur">
                  <el-select v-model="filters.parcellaire.producteur" v-waves class="filter-item" placeholder="Sélectionner" filterable>
                    <el-option v-for="item in producteurs" :key="item.id" :label="uppercaseFirst(item.nom)" :value="item.id" :disabled="!item.is_active" />
                  </el-select>
                </el-form-item>
              </el-form>
            </div>
            <div class="download-pane__actions">
              <el-button type="primary" size="medium" icon="el-icon-download" :loading="downloading" :disabled="isDownloadDisabled('parcellaire')" @click="download('parcellaire')">Télécharger le ZIP</el-button>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="Fiches de bon de livraison" name="bon_livraison">
          <div v-if="loading" class="download-tab-spinner">
            <div class="download-tab-spinner__oval"><i class="el-icon-loading" /><span>Chargement des données...</span></div>
          </div>
          <div v-else class="download-pane">
            <div class="download-pane__header">
              <h2 class="download-pane__title">Fiches de bon de livraison</h2>
              <el-button type="text" size="small" icon="el-icon-refresh-left" @click="initSearch">Réinitialiser</el-button>
            </div>
            <div class="download-pane__filters">
              <span class="download-pane__filters-label">Filtres</span>
              <div class="download-count-block download-count-block--top" :class="{ 'download-count-block--loading': loadingCount.bon_livraison }">
                <template v-if="loadingCount.bon_livraison">
                  <div class="download-count-loading-oval">
                    <i class="el-icon-loading" />
                    <span class="count-text">Comptage en cours...</span>
                  </div>
                </template>
                <template v-else-if="countInfo.bon_livraison !== undefined && countInfo.bon_livraison !== null">
                  <div class="download-count-badge download-count-badge--ok">
                    <i class="el-icon-data-analysis" />
                    <span>Résultat du comptage : {{ countInfo.bon_livraison.count }} {{ countInfo.bon_livraison.type_label }}</span>
                  </div>
                </template>
                <template v-else>
                  <div class="download-count-badge download-count-badge--zero">
                    <i class="el-icon-info" />
                    <span>Comptage indisponible pour le moment. Ajustez un filtre pour relancer le comptage.</span>
                  </div>
                </template>
              </div>
              <el-form :inline="true" :model="filters.bon_livraison" class="download-form">
                <el-form-item label="Campagne agricole">
                  <el-select v-model="filters.bon_livraison.campagne" placeholder="Sélectionner" filterable>
                    <el-option v-for="item in campagnes_agricoles" :key="item.id" :label="item.periode" :value="item.id" />
                  </el-select>
                </el-form-item>
                <!-- Sélections hiérarchiques des localités -->
                <el-form-item label="Région">
                  <el-select v-model="filters.bon_livraison.region" placeholder="Sélectionner" filterable clearable @change="onRegionChange('bon_livraison')">
                    <el-option v-for="item in regions" :key="item.id" :label="item.nom" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Zone">
                  <el-select v-model="filters.bon_livraison.zone" placeholder="Sélectionner" filterable clearable @change="onZoneChange('bon_livraison')">
                    <el-option v-for="item in zones" :key="item.id" :label="item.nom" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Commune">
                  <el-select v-model="filters.bon_livraison.commune" placeholder="Sélectionner" filterable clearable @change="onCommuneChange('bon_livraison')">
                    <el-option v-for="item in communes" :key="item.id" :label="item.nom" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Village">
                  <el-select v-model="filters.bon_livraison.village" placeholder="Sélectionner" filterable clearable @change="onVillageChange('bon_livraison')">
                    <el-option v-for="item in villages" :key="item.id" :label="item.nom" :value="item.id" :disabled="!item.is_active" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Unité de production">
                  <el-select v-model="filters.bon_livraison.unite_production" placeholder="Sélectionner" filterable @change="getUPGroupementsList('bon_livraison')">
                    <el-option v-for="item in unite_productions" :key="item.id" :label="item.nom" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Groupement">
                  <el-select v-model="filters.bon_livraison.groupement" v-waves class="filter-item" placeholder="Sélectionner" filterable @change="getGroupProducteursList('bon_livraison')">
                    <el-option v-for="item in groupements" :key="item.id" :label="uppercaseFirst(item.nom)" :value="item.id" :disabled="!item.is_active" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Producteur">
                  <el-select v-model="filters.bon_livraison.producteur" placeholder="Sélectionner" filterable>
                    <el-option v-for="item in producteurs" :key="item.id" :label="`${item.nom} ${item.prenom}`" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Contrôleur">
                  <el-select v-model="filters.bon_livraison.controleur" placeholder="Sélectionner" filterable clearable>
                    <el-option
                      v-for="item in controleurs"
                      :key="item.id"
                      :label="uppercaseFirst(item.nom)"
                      :value="item.id"
                      :disabled="!item.is_active"
                    />
                  </el-select>
                </el-form-item>

                <el-form-item label="Période">
                  <el-date-picker
                    v-model="filters.bon_livraison.dateRange"
                    type="daterange"
                    range-separator="à"
                    start-placeholder="Date début"
                    end-placeholder="Date fin"
                    format="dd/MM/yyyy"
                  />
                </el-form-item>
              </el-form>
            </div>
            <div class="download-pane__actions">
              <el-button type="primary" size="medium" icon="el-icon-download" :loading="downloading" :disabled="isDownloadDisabled('bon_livraison')" @click="download('bon_livraison')">Télécharger le ZIP</el-button>
            </div>
          </div>
        </el-tab-pane>

        <!-- <el-tab-pane label="Fiches de bon de livraison" name="bon_livraison">
        <div v-if="loading" class="tab-spinner">
          <el-spinner />
          <p>Chargement des données...</p>
        </div>
        <div v-else>
          <div class="page-title">
            <h2>Fiches de bon de livraison</h2>
          </div>
          <el-link type="primary" class="wd-20 filter-item" @click="initSearch">Réinitialiser</el-link>
          <el-form :inline="true" :model="filters.bon_livraison">
            <el-form-item label="Campagne agricole">
              <el-select v-model="filters.bon_livraison.campagne" placeholder="Sélectionner" filterable>
                <el-option v-for="item in campagnes_agricoles" :key="item.id" :label="item.periode" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="Unité de production">
              <el-select v-model="filters.bon_livraison.unite_production" placeholder="Sélectionner" filterable @change="getUPGroupementsList">
                <el-option v-for="item in unite_productions" :key="item.id" :label="item.nom" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="Groupement">
              <el-select v-model="filters.bon_livraison.groupement" v-waves class="filter-item" placeholder="Sélectionner" filterable @change="getGroupProducteursList">
                <el-option v-for="item in groupements" :key="item.id" :label="uppercaseFirst(item.nom)" :value="item.id" :disabled="!item.is_active" />
              </el-select>
            </el-form-item>
            <el-form-item label="Producteur">
              <el-select v-model="filters.bon_livraison.producteur" v-waves class="filter-item" placeholder="Sélectionner" filterable>
                <el-option v-for="item in producteurs" :key="item.id" :label="uppercaseFirst(item.nom)" :value="item.id" :disabled="!item.is_active" />
              </el-select>
            </el-form-item>
          </el-form>
          <el-button type="primary" :loading="downloading" @click="download('bon_livraison')">Télécharger</el-button>
        </div>
      </el-tab-pane> -->

        <!-- <el-tab-pane label="Fiches collectes" name="collecte">
        <div v-if="loading" class="tab-spinner">
          <el-spinner />
          <p>Chargement des données...</p>
        </div>
        <div v-else>
          <div class="page-title">
            <h2>{{ $t('fiches.fichesCollecte') }}</h2>
          </div>
          <el-link type="primary" class="wd-20 filter-item" @click="initSearch">Réinitialiser</el-link>
          <el-form :inline="true" :model="filters.collecte">
            <el-form-item label="Campagne agricole">
              <el-select v-model="filters.collecte.campagne" placeholder="Sélectionner" filterable>
                <el-option v-for="item in campagnes_agricoles" :key="item.id" :label="item.periode" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="Unité de production">
              <el-select v-model="filters.collecte.unite_production" placeholder="Sélectionner" filterable @change="getUPGroupementsList">
                <el-option v-for="item in unite_productions" :key="item.id" :label="item.nom" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="Groupement">
              <el-select v-model="filters.collecte.groupement" v-waves class="filter-item" placeholder="Sélectionner" filterable @change="getGroupProducteursList">
                <el-option v-for="item in groupements" :key="item.id" :label="uppercaseFirst(item.nom)" :value="item.id" :disabled="!item.is_active" />
              </el-select>
            </el-form-item>
            <el-form-item label="Producteur">
              <el-select v-model="filters.collecte.producteur" v-waves class="filter-item" placeholder="Sélectionner" filterable>
                <el-option v-for="item in producteurs" :key="item.id" :label="uppercaseFirst(item.nom)" :value="item.id" :disabled="!item.is_active" />
              </el-select>
            </el-form-item>
          </el-form>
          <el-button type="primary" @click="download('collecte')">Télécharger</el-button>
        </div>
      </el-tab-pane> -->
        <el-tab-pane label="Fiches collectes" name="collecte">
          <div v-if="loading" class="download-tab-spinner">
            <div class="download-tab-spinner__oval"><i class="el-icon-loading" /><span>Chargement des données...</span></div>
          </div>
          <div v-else class="download-pane">
            <div class="download-pane__header">
              <h2 class="download-pane__title">{{ $t('fiches.fichesCollecte') }}</h2>
              <el-button type="text" size="small" icon="el-icon-refresh-left" @click="initSearch">Réinitialiser</el-button>
            </div>
            <div class="download-pane__filters">
              <span class="download-pane__filters-label">Filtres</span>
              <div class="download-count-block download-count-block--top" :class="{ 'download-count-block--loading': loadingCount.collecte }">
                <template v-if="loadingCount.collecte">
                  <div class="download-count-loading-oval">
                    <i class="el-icon-loading" />
                    <span class="count-text">Comptage en cours...</span>
                  </div>
                </template>
                <template v-else-if="countInfo.collecte !== undefined && countInfo.collecte !== null">
                  <div class="download-count-badge download-count-badge--ok">
                    <i class="el-icon-data-analysis" />
                    <span>Résultat du comptage : {{ countInfo.collecte.count }} {{ countInfo.collecte.type_label }}</span>
                  </div>
                </template>
                <template v-else>
                  <div class="download-count-badge download-count-badge--zero">
                    <i class="el-icon-info" />
                    <span>Comptage indisponible pour le moment. Ajustez un filtre pour relancer le comptage.</span>
                  </div>
                </template>
              </div>
              <el-form :inline="true" :model="filters.collecte" class="download-form">
                <el-form-item label="Campagne agricole">
                  <el-select v-model="filters.collecte.campagne" placeholder="Sélectionner" filterable>
                    <el-option v-for="item in campagnes_agricoles" :key="item.id" :label="item.periode" :value="item.id" />
                  </el-select>
                </el-form-item>
                <!-- Sélections hiérarchiques des localités -->
                <el-form-item label="Région">
                  <el-select v-model="filters.collecte.region" placeholder="Sélectionner" filterable clearable @change="onRegionChange('collecte')">
                    <el-option v-for="item in regions" :key="item.id" :label="item.nom" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Zone">
                  <el-select v-model="filters.collecte.zone" placeholder="Sélectionner" filterable clearable @change="onZoneChange('collecte')">
                    <el-option v-for="item in zones" :key="item.id" :label="item.nom" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Commune">
                  <el-select v-model="filters.collecte.commune" placeholder="Sélectionner" filterable clearable @change="onCommuneChange('collecte')">
                    <el-option v-for="item in communes" :key="item.id" :label="item.nom" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Village">
                  <el-select v-model="filters.collecte.village" placeholder="Sélectionner" filterable clearable @change="onVillageChange('collecte')">
                    <el-option v-for="item in villages" :key="item.id" :label="item.nom" :value="item.id" :disabled="!item.is_active" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Unité de production">
                  <el-select v-model="filters.collecte.unite_production" placeholder="Sélectionner" filterable @change="getUPGroupementsList('collecte')">
                    <el-option v-for="item in unite_productions" :key="item.id" :label="item.nom" :value="item.id" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Groupement">
                  <el-select v-model="filters.collecte.groupement" v-waves class="filter-item" placeholder="Sélectionner" filterable @change="getGroupProducteursList('collecte')">
                    <el-option v-for="item in groupements" :key="item.id" :label="uppercaseFirst(item.nom)" :value="item.id" :disabled="!item.is_active" />
                  </el-select>
                </el-form-item>
                <el-form-item label="Producteur">
                  <el-select v-model="filters.collecte.producteur" placeholder="Sélectionner" filterable>
                    <el-option v-for="item in producteurs" :key="item.id" :label="uppercaseFirst(item.nom)" :value="item.id" />
                  </el-select>
                </el-form-item>

                <el-form-item label="Certification">
                  <el-input v-model="filters.collecte.certification" placeholder="Ex: BIO, RA..." clearable />
                </el-form-item>

                <el-form-item label="Période">
                  <el-date-picker
                    v-model="filters.collecte.dateRange"
                    type="daterange"
                    range-separator="à"
                    start-placeholder="Date début"
                    end-placeholder="Date fin"
                    format="dd/MM/yyyy"
                  />
                </el-form-item>
              </el-form>
            </div>
            <div class="download-pane__actions">
              <el-button type="primary" size="medium" icon="el-icon-download" :loading="downloading" :disabled="isDownloadDisabled('collecte')" @click="download('collecte')">Télécharger le ZIP</el-button>
            </div>
          </div>
        </el-tab-pane>

      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import Resource from '@/api/resource';
import request from '@/utils/request';
import waves from '@/directive/waves'; // Directives
import permission from '@/directive/permission'; //  directive Permission
import role from '@/directive/role'; // Directives Role
import checkPermission from '@/utils/permission'; // Vérification Permission
import checkRole from '@/utils/role';
import { ref, reactive } from 'vue';

const uniteProdResource = new Resource('unite_productions');
const campResource = new Resource('campagne_agricoles');
const downloadResource = new Resource('downloads');
const controleurResource = new Resource('controleurs');
const groupementProducteurResource = new Resource('groupement_producteurs');
const villageResource = new Resource('villages');
const regionResource = new Resource('regions');
const zoneResource = new Resource('zones');
const communeResource = new Resource('communes');
const scoopResource = new Resource('scoops');
export default {
  name: 'Download',
  directives: { waves, permission, role },
  data() {
    return {
      unite_productions: null,
      campagnes_agricoles: null,
      controleurs: [],
      groupements: [],
      producteurs: [],
      villages: [],
      regions: [],
      zones: [],
      communes: [],
      scoops: [],
      downloading: false,
      downloadingMulti: false,
      loading: true,
      multiTypes: ['contrats'],
      availableMultiTypes: [
        { value: 'contrats', label: 'Contrats' },
        { value: 'collecte', label: 'Collecte' },
        { value: 'formations', label: 'Formations' },
        { value: 'controle_interne', label: 'Contrôle interne' },
        { value: 'parcellaire', label: 'Parcellaire' },
        { value: 'bon_livraison', label: 'Bon de livraison' },
      ],
      multiCountInfo: null,
      loadingCountMulti: false,
      fullscreenLoadingMulti: false,
      countInfo: {
        contrats: null,
        formations: null,
        controle_interne: null,
        parcellaire: null,
        bon_livraison: null,
        collecte: null,
      },
      loadingCount: {
        contrats: false,
        formations: false,
        controle_interne: false,
        parcellaire: false,
        bon_livraison: false,
        collecte: false,
      },
      uniteProductionId: null,
      query: {
        page: 1,
        limit: 100,
        keyword: '',
      },
      activeTab: ref('contrats'),
      filters: reactive({
        contrats: { campagne: '', scoop: '', region: '', zone: '', commune: '', village: '', unite_production: '', groupement: '' },
        formations: { campagne: '', controleur: '' },
        controle_interne: { campagne: '', region: '', zone: '', commune: '', village: '', unite_production: '', groupement: '', producteur: '' },
        parcellaire: { campagne: '', region: '', zone: '', commune: '', village: '', unite_production: '', groupement: '', producteur: '' },
        bon_livraison: { campagne: '', region: '', zone: '', commune: '', village: '', unite_production: '', groupement: '', producteur: '', controleur: '' },
        collecte: { campagne: '', region: '', zone: '', commune: '', village: '', unite_production: '', groupement: '', producteur: '', certification: '', dateRange: null },
        multi: { campagne: '', region: '', zone: '', commune: '', village: '', unite_production: '', groupement: '', producteur: '', controleur: '', certification: '', dateRange: null },
      }),
      hasLoadedFormationData: false,
      countDebounceTimer: null,
    };
  },
  computed: {
    activeCountKey() {
      return this.normalizeFilterType(this.activeTab);
    },
    isGlobalOverlayVisible() {
      return this.downloading || this.downloadingMulti || this.loadingCount[this.activeCountKey] === true || this.loadingCountMulti;
    },
  },
  watch: {
    filters: {
      handler() {
        if (this.countDebounceTimer) {
          clearTimeout(this.countDebounceTimer);
        }
        this.countDebounceTimer = setTimeout(() => {
          if (this.activeTab === 'multi') {
            this.getMultiDownloadCount();
          } else {
            this.getDownloadCount(this.activeTab);
          }
        }, 400);
      },
      deep: true,
    },
    multiTypes() {
      if (this.activeTab === 'multi') {
        this.getMultiDownloadCount();
      }
    },
  },
  async created() {
    this.loading = true;
    this.getCampagneList();
    await this.campEnCours();
    this.getScoopsList();
    this.getUniteProdList();
    this.getVillagesList();
    this.getRegionsList();
    this.getDownloadCount('contrats');
  },
  methods: {
    checkPermission,
    checkRole,
    normalizeFilterType(type) {
      if (type === 'formation') {
        return 'formations';
      }
      return type;
    },
    hasCampagne(type) {
      const normalizedType = this.normalizeFilterType(type);
      return !!(this.filters[normalizedType] && this.filters[normalizedType].campagne);
    },
    isOnlyCampagneFilter(type) {
      const normalizedType = this.normalizeFilterType(type);
      if (normalizedType !== 'contrats') {
        return false;
      }
      const filter = this.filters.contrats || {};
      const optionalKeys = ['scoop', 'region', 'zone', 'commune', 'village', 'unite_production', 'groupement'];
      return optionalKeys.every((key) => !filter[key]);
    },
    isDownloadDisabled(type) {
      const normalizedType = this.normalizeFilterType(type);
      if (!this.hasCampagne(normalizedType)) {
        return true;
      }
      return false;
    },
    async parseBlobError(responseData) {
      if (!responseData || typeof Blob === 'undefined' || !(responseData instanceof Blob)) {
        return null;
      }
      const text = await responseData.text();
      if (!text) {
        return null;
      }
      try {
        return JSON.parse(text);
      } catch (e) {
        return null;
      }
    },
    /** Paramètres POST `/downloads/export-background` (même contrat que l’onglet Contrats, tous types). */
    buildExportBackgroundParams(normalizedType) {
      const params = { type: normalizedType, ...this.filters[normalizedType] };
      const f = this.filters[normalizedType];
      if (f && f.dateRange && Array.isArray(f.dateRange)) {
        params.dateRange = f.dateRange;
      }
      return params;
    },
    async downloadContratsCampaignFolder() {
      const response = await request({
        url: '/downloads/contrats-campagne-folder',
        method: 'get',
        params: this.filters.contrats,
        responseType: 'blob',
        headers: { Accept: 'application/zip' },
      });
      const blob = response.data || response;
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = this.genererNomFichier('contrats');
      link.click();
    },
    uppercaseFirst(str) {
      if (!str) {
        return '';
      }
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },
    async getDownloadCount(type) {
      const normalizedType = this.normalizeFilterType(type);
      if (!this.filters[normalizedType]) {
        return;
      }
      const key = normalizedType;
      const needsCampagne = ['contrats', 'formations', 'controle_interne', 'parcellaire', 'bon_livraison', 'collecte'].includes(normalizedType) &&
        !this.filters[normalizedType].campagne;
      if (needsCampagne) {
        this.countInfo[key] = null;
        return;
      }
      this.loadingCount[key] = true;
      try {
        const params = this.buildExportBackgroundParams(normalizedType);
        const response = await downloadResource.getCount(params);
        const payload = (response && Object.prototype.hasOwnProperty.call(response, 'data'))
          ? response.data
          : response;
        this.countInfo[key] = (payload && typeof payload.count === 'number')
          ? payload
          : null;
      } catch (err) {
        this.countInfo[key] = null;
      } finally {
        this.loadingCount[key] = false;
      }
    },
    async getMultiDownloadCount() {
      if (!this.filters.multi.campagne || this.multiTypes.length === 0) {
        this.multiCountInfo = null;
        return;
      }
      this.loadingCountMulti = true;
      this.fullscreenLoadingMulti = true;
      try {
        const response = await downloadResource.countMulti({
          types: this.multiTypes,
          filters: this.filters.multi,
        });
        const payload = (response && Object.prototype.hasOwnProperty.call(response, 'data'))
          ? response.data
          : response;
        this.multiCountInfo = payload || null;
      } catch (err) {
        this.multiCountInfo = null;
      } finally {
        this.loadingCountMulti = false;
        this.fullscreenLoadingMulti = false;
      }
    },
    async exportMultiBackground() {
      if (!this.filters.multi.campagne) {
        this.$message.warning('La campagne agricole est obligatoire.');
        return;
      }
      if (!this.multiTypes.length) {
        this.$message.warning('Sélectionnez au moins un type de fiche.');
        return;
      }
      this.downloadingMulti = true;
      this.fullscreenLoadingMulti = true;
      try {
        await downloadResource.exportBackgroundMulti({
          types: this.multiTypes,
          filters: this.filters.multi,
          notify_email: 'projectmanagersoycain@gmail.com',
        });
        this.$message.success('Export multi-types lancé. Le lien de téléchargement sera envoyé par email.');
      } catch (err) {
        this.$message.error(err?.response?.data?.message || 'Erreur lors du lancement de l’export multi-types.');
      } finally {
        this.downloadingMulti = false;
        this.fullscreenLoadingMulti = false;
      }
    },
    async download(type) {
      const normalizedType = this.normalizeFilterType(type);
      const key = normalizedType;
      const info = this.countInfo[key];
      if (!this.hasCampagne(normalizedType)) {
        this.$message.warning('La campagne agricole est obligatoire.');
        return;
      }
      const backgroundThreshold = (info && typeof info.background_threshold === 'number') ? info.background_threshold : 2000;
      if (info && typeof info.count === 'number' && info.count > backgroundThreshold) {
        const params = this.buildExportBackgroundParams(normalizedType);
        this.$msgbox({
          title: 'Export volumineux',
          message: `Le comptage a trouvé ${info.count} fichiers. Voulez-vous lancer la préparation en arrière-plan et recevoir le lien de téléchargement par email ?`,
          showCancelButton: true,
          confirmButtonText: 'Oui, lancer en arrière-plan',
          cancelButtonText: 'Annuler',
          type: 'warning',
        }).then(() => {
          this.downloading = true;
          return downloadResource.exportBackground(params);
        }).then(() => {
          this.$message.success(`Volume important (${info.count} fichiers). L'export est lancé en arrière-plan et sera envoyé par email.`);
        }).catch((err) => {
          if (err !== 'cancel') {
            this.$message.error(err?.response?.data?.message || 'Erreur lors de la demande d\'export par email.');
          }
        }).finally(() => {
          this.downloading = false;
        });
        return;
      }
      const endpoint = normalizedType === 'collecte' ? 'collectes' : normalizedType;
      const controller = new AbortController();
      const LONG_DOWNLOAD_MS = 45000;
      let longTimer = null;

      const showLongDownloadPopup = () => {
        // Masquer l’overlay « Téléchargement en cours… » avant la popup (sinon les deux se superposent).
        this.downloading = false;
        let choseContinuerAttente = false;
        this.$msgbox({
          title: 'Téléchargement long',
          message: 'Les données sont volumineuses. Nous pouvons préparer le fichier en arrière-plan et vous envoyer le lien de téléchargement par email lorsqu\'il sera prêt. Souhaitez-vous continuer ainsi ?',
          showCancelButton: true,
          confirmButtonText: 'Recevoir par email',
          cancelButtonText: 'Continuer à attendre',
          type: 'info',
        }).then(() => {
          controller.abort();
          const params = this.buildExportBackgroundParams(normalizedType);
          this.downloading = true;
          return downloadResource.exportBackground(params);
        }).then(() => {
          this.$message.success('Votre export est en cours de préparation. Vous recevrez un email avec le lien de téléchargement sous peu.');
        }).catch((err) => {
          if (err === 'cancel') {
            // L’utilisateur poursuit l’attente du ZIP : réafficher l’overlay pendant que la requête continue.
            choseContinuerAttente = true;
            this.downloading = true;
            return;
          }
          this.$message.error(err?.response?.data?.message || 'Erreur lors de la demande d\'export par email.');
        }).finally(() => {
          if (!choseContinuerAttente) {
            this.downloading = false;
          }
        });
      };

      longTimer = setTimeout(showLongDownloadPopup, LONG_DOWNLOAD_MS);
      this.downloading = true;

      try {
        const response = await request({
          url: '/downloads/' + endpoint,
          method: 'get',
          params: this.filters[normalizedType],
          responseType: 'blob',
          headers: { Accept: 'application/zip' },
          signal: controller.signal,
          timeout: 600000,
        });
        clearTimeout(longTimer);
        const blob = response.data || response;
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = this.genererNomFichier(type);
        link.click();
      } catch (err) {
        clearTimeout(longTimer);
        if (err.code === 'ERR_CANCELED' || err.name === 'CanceledError' || (err.message && err.message.includes('abort'))) {
          return;
        }
        console.error('Erreur téléchargement groupé:', err);
        const errorData = await this.parseBlobError(err?.response?.data);
        if (
          normalizedType === 'contrats' &&
          err?.response?.status === 404 &&
          errorData?.message === 'Aucun contrat trouvé pour cette campagne.' &&
          this.isOnlyCampagneFilter('contrats')
        ) {
          this.$message.warning('Aucun contrat trouvé avec le filtre actuel. Téléchargement du dossier complet de contrats de la campagne...');
          await this.downloadContratsCampaignFolder();
          return;
        }
        if (err.response && err.response.status === 404) {
          this.$message.error(errorData?.message || 'Aucun fichier trouvé pour les critères sélectionnés');
        } else if (err.response && err.response.status === 400) {
          const msg = (errorData && typeof errorData === 'object' && errorData.message)
            ? errorData.message
            : 'Téléchargement impossible.';
          this.$alert(msg, 'Téléchargement impossible', { type: 'warning', confirmButtonText: 'OK' });
        } else {
          this.$message.error('Erreur lors du téléchargement');
        }
      } finally {
        this.downloading = false;
      }
    },
    async handleTabClick(tab) {
      if (tab.name === 'multi') {
        this.filters.multi.campagne = this.campagne_encours.id;
        this.getMultiDownloadCount();
        return;
      }
      if (tab.name === 'contrats') {
        await this.initSearch();
      } else if (tab.name === 'formation' && !this.hasLoadedFormationData) {
        this.filters.formations.campagne = this.campagne_encours.id;
        this.getControleurList();
        this.hasLoadedFormationData = true;
      } else if (tab.name === 'controle_interne') {
        this.filters.controle_interne.campagne = this.campagne_encours.id;
      } else if (tab.name === 'parcellaire') {
        this.filters.parcellaire.campagne = this.campagne_encours.id;
      } else if (tab.name === 'bon_livraison') {
        this.filters.bon_livraison.campagne = this.campagne_encours.id;
        if (!this.controleurs.length) {
          this.getControleurList();
        }
      } else if (tab.name === 'collecte') {
        this.filters.collecte.campagne = this.campagne_encours.id;
      }
      this.getDownloadCount(tab.name);
    },
    async getUniteProdList() {
      const { data } = await uniteProdResource.list();
      console.log('UNITE PRODUCTION', data);
      this.unite_productions = data;
      this.loading = false;
    },
    async getCampagneList() {
      const { data } = await campResource.list();
      this.campagnes_agricoles = data;
    },
    async getScoopsList() {
      try {
        const { data } = await scoopResource.list({ limit: 1000 });
        this.scoops = data || [];
      } catch (error) {
        console.error('Erreur lors de la récupération des scoops:', error);
        this.scoops = [];
      }
    },
    async getRegionsList() {
      try {
        const { data } = await regionResource.sublist('?typeApi="all"', { limit: 1000 });
        this.regions = data || [];
      } catch (error) {
        console.error('Erreur lors de la récupération des régions:', error);
        this.regions = [];
      }
    },
    async loadAllZonesAndCommunes() {
      try {
        const { data: zonesData } = await zoneResource.sublist('?typeApi="all"', { limit: 1000 });
        this.zones = zonesData || [];
      } catch (error) {
        console.error('Erreur lors de la récupération des zones:', error);
        this.zones = [];
      }

      try {
        const { data: communesData } = await communeResource.sublist('?typeApi="all"', { limit: 1000 });
        this.communes = communesData || [];
      } catch (error) {
        console.error('Erreur lors de la récupération des communes:', error);
        this.communes = [];
      }
    },
    async onRegionChange(filterType) {
      const filter = this.filters[filterType];
      // Réinitialiser uniquement les sélections enfants si la région est désélectionnée
      if (!filter.region) {
        filter.zone = '';
        filter.commune = '';
        filter.village = '';
      }
      // Toujours réinitialiser les sélections dépendantes des unités de production
      filter.unite_production = '';
      filter.groupement = '';
      filter.producteur = '';
      this.groupements = [];
      this.producteurs = [];

      // Recharger tous les champs en fonction de la sélection actuelle
      await this.reloadAllFields(filterType);
    },
    async onZoneChange(filterType) {
      const filter = this.filters[filterType];
      // Réinitialiser uniquement les sélections enfants si la zone est désélectionnée
      if (!filter.zone) {
        filter.commune = '';
        filter.village = '';
      }
      // Toujours réinitialiser les sélections dépendantes des unités de production
      filter.unite_production = '';
      filter.groupement = '';
      filter.producteur = '';
      this.groupements = [];
      this.producteurs = [];

      // Recharger tous les champs en fonction de la sélection actuelle
      await this.reloadAllFields(filterType);
    },
    async onCommuneChange(filterType) {
      const filter = this.filters[filterType];
      // Réinitialiser uniquement les sélections enfants si la commune est désélectionnée
      if (!filter.commune) {
        filter.village = '';
      }
      // Toujours réinitialiser les sélections dépendantes des unités de production
      filter.unite_production = '';
      filter.groupement = '';
      filter.producteur = '';
      this.groupements = [];
      this.producteurs = [];

      // Recharger tous les champs en fonction de la sélection actuelle
      await this.reloadAllFields(filterType);
    },
    async onVillageChange(filterType) {
      const filter = this.filters[filterType];
      // Réinitialiser les sélections dépendantes des unités de production
      filter.unite_production = '';
      filter.groupement = '';
      filter.producteur = '';
      this.groupements = [];
      this.producteurs = [];

      // Recharger tous les champs en fonction de la sélection actuelle
      await this.reloadAllFields(filterType);
    },
    async reloadAllFields(filterType) {
      const filter = this.filters[filterType];

      // 1. Charger les zones si une région est sélectionnée
      if (filter.region) {
        try {
          const { data } = await zoneResource.sublist(`?typeApi="all"&region_id=${filter.region}`, { limit: 1000 });
          this.zones = data || [];
        } catch (error) {
          console.error('Erreur lors de la récupération des zones:', error);
          this.zones = [];
        }
      } else {
        // Si pas de région, charger toutes les zones
        try {
          const { data } = await zoneResource.sublist('?typeApi="all"', { limit: 1000 });
          this.zones = data || [];
        } catch (error) {
          console.error('Erreur lors de la récupération des zones:', error);
          this.zones = [];
        }
      }

      // 2. Charger les communes selon zone ou région
      if (filter.zone) {
        try {
          const { data } = await communeResource.sublist(`?typeApi="all"&zone_id=${filter.zone}`, { limit: 1000 });
          this.communes = data || [];
        } catch (error) {
          console.error('Erreur lors de la récupération des communes:', error);
          this.communes = [];
        }
      } else if (filter.region) {
        // Si zone non sélectionnée mais région oui, utiliser region_id directement
        try {
          const { data } = await communeResource.sublist(`?typeApi="all"&region_id=${filter.region}`, { limit: 1000 });
          this.communes = data || [];
        } catch (error) {
          console.error('Erreur lors de la récupération des communes:', error);
          this.communes = [];
        }
      } else {
        // Si rien n'est sélectionné, charger toutes les communes
        try {
          const { data } = await communeResource.sublist('?typeApi="all"', { limit: 1000 });
          this.communes = data || [];
        } catch (error) {
          console.error('Erreur lors de la récupération des communes:', error);
          this.communes = [];
        }
      }

      // 3. Charger les villages selon commune, zone ou région
      if (filter.commune) {
        try {
          const { data } = await villageResource.list({ commune_id: filter.commune, limit: 1000 });
          this.villages = data || [];
        } catch (error) {
          console.error('Erreur lors de la récupération des villages:', error);
          this.villages = [];
        }
      } else if (filter.zone) {
        // Si commune non sélectionnée mais zone oui, utiliser zone_id directement
        try {
          // Utiliser zone_id directement au lieu de boucler sur les communes
          const { data } = await villageResource.list({ zone_id: filter.zone, limit: 1000 });
          this.villages = data || [];
        } catch (error) {
          console.error('Erreur lors de la récupération des villages:', error);
          this.villages = [];
        }
      } else if (filter.region) {
        // Si zone et commune non sélectionnées mais région oui, utiliser region_id directement
        try {
          // Utiliser region_id directement au lieu de boucler sur les communes
          const { data } = await villageResource.list({ region_id: filter.region, limit: 1000 });
          this.villages = data || [];
        } catch (error) {
          console.error('Erreur lors de la récupération des villages:', error);
          this.villages = [];
        }
      } else {
        // Si rien n'est sélectionné, charger tous les villages
        try {
          const { data } = await villageResource.list({ limit: 1000 });
          this.villages = data || [];
        } catch (error) {
          console.error('Erreur lors de la récupération des villages:', error);
          this.villages = [];
        }
      }

      // 4. Filtrer les unités de production selon les localités sélectionnées
      await this.filterUniteProductionsByLocalites(filterType);
    },
    async filterUniteProductionsByLocalites(filterType) {
      const filter = this.filters[filterType];
      const params = {};

      // Priorité : village > commune > zone > région
      if (filter.village) {
        params.village_id = filter.village;
      } else if (filter.commune) {
        params.commune_id = filter.commune;
      } else if (filter.zone) {
        params.zone_id = filter.zone;
      } else if (filter.region) {
        params.region_id = filter.region;
      }

      if (Object.keys(params).length > 0) {
        try {
          // Utiliser l'endpoint spécifique pour filtrer par localités
          const response = await uniteProdResource.sublist('/filter-by-localites', params);
          // L'intercepteur axios retourne déjà response.data du serveur
          // sendResponse retourne {success: true, data: [...], message: "..."}
          // Donc response est {success, data, message} et response.data contient le tableau
          this.unite_productions = response.data || [];
        } catch (error) {
          console.error('Erreur lors du filtrage des unités de production:', error);
          this.unite_productions = [];
        }
      } else {
        await this.getUniteProdList();
      }
    },
    async getUPGroupementsList(filterTypeOrUpId) {
      // Support de l'ancienne signature pour compatibilité
      let filterType = 'controle_interne';
      let upId = null;

      if (typeof filterTypeOrUpId === 'string') {
        filterType = filterTypeOrUpId;
        const filter = this.filters[filterType];
        upId = filter.unite_production;
      } else {
        upId = filterTypeOrUpId;
      }

      // Réinitialiser les sélections dépendantes
      const filter = this.filters[filterType];
      filter.groupement = '';
      filter.producteur = '';
      this.producteurs = [];

      if (!upId) {
        this.groupements = [];
        return;
      }

      const params = { unite_production_id: upId };

      // Ajouter les filtres de localités si disponibles
      if (filter.village) {
        params.village_id = filter.village;
      } else if (filter.commune) {
        params.commune_id = filter.commune;
      } else if (filter.zone) {
        params.zone_id = filter.zone;
      } else if (filter.region) {
        params.region_id = filter.region;
      }

      try {
        if (Object.keys(params).length > 1) {
          // Filtrer par localités via l'API
          const response = await new Resource('groupements').sublist('/filter-by-localites', params);
          // L'intercepteur axios retourne déjà response.data du serveur
          // sendResponse retourne {success: true, data: [...], message: "..."}
          // Donc response est {success, data, message} et response.data contient le tableau
          this.groupements = response.data || [];
        } else {
          // Utiliser l'ancienne méthode si pas de filtre localité
          this.groupements = this.unite_productions.find((up) => up.id === upId)?.groupements || [];
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des groupements:', error);
        this.groupements = [];
      }
    },
    async getGroupProducteursList(filterTypeOrGroupId) {
      // Support de l'ancienne signature pour compatibilité
      let filterType = 'controle_interne';
      let groupId = null;

      if (typeof filterTypeOrGroupId === 'string') {
        filterType = filterTypeOrGroupId;
        const filter = this.filters[filterType];
        groupId = filter.groupement;
      } else {
        groupId = filterTypeOrGroupId;
      }

      if (!groupId) {
        this.producteurs = [];
        return;
      }

      this.loading = true;
      const filter = this.filters[filterType];
      const params = { groupement_id: groupId };

      // Ajouter les filtres de localités si disponibles
      if (filter.village) {
        params.village_id = filter.village;
      } else if (filter.commune) {
        params.commune_id = filter.commune;
      } else if (filter.zone) {
        params.zone_id = filter.zone;
      } else if (filter.region) {
        params.region_id = filter.region;
      }

      try {
        if (Object.keys(params).length > 1) {
          // Filtrer par localités via l'API
          const response = await new Resource('producteurs').sublist('/filter-by-localites', params);
          // L'intercepteur axios retourne déjà response.data du serveur
          // sendResponse retourne {success: true, data: [...], message: "..."}
          // Donc response est {success, data, message} et response.data contient le tableau
          this.producteurs = response.data || [];
          this.loading = false;
        } else {
          // Utiliser l'ancienne méthode si pas de filtre localité
          await groupementProducteurResource.get(groupId)
            .then(response => {
              this.loading = false;
              this.producteurs = response.data;
            })
            .catch(error => {
              this.loading = false;
              console.error('Erreur lors de la récupération des producteurs:', error);
              this.$message.error('Erreur lors de la récupération des producteurs');
            });
        }
      } catch (error) {
        this.loading = false;
        console.error('Erreur lors de la récupération des producteurs:', error);
        this.$message.error('Erreur lors de la récupération des producteurs');
      }
    },
    async campEnCours(){
      const { data } = await campResource.sublist('/en_cours');
      this.campagne_encours = data;
      this.filters.contrats.campagne = data.id;
      this.filters.formations.campagne = data.id;
      this.filters.controle_interne.campagne = data.id;
      this.filters.parcellaire.campagne = data.id;
      this.filters.bon_livraison.campagne = data.id;
      this.filters.collecte.campagne = data.id;
      await this.getDownloadCount('contrats');
    },
    genererNomFichier(type) {
      // Récupère les filtres selon le type
      const filtres = this.filters[type] || {};
      let campagne = '';
      let nomUp = '';
      let nomGroupement = '';
      let nomControleur = '';

      // Récupère la période de la campagne sélectionnée
      if (filtres.campagne && this.campagnes_agricoles) {
        const camp = this.campagnes_agricoles.find(c => c.id === filtres.campagne);
        campagne = camp ? camp.periode : '';
      }

      // Récupère le nom de l'unité de production sélectionnée
      if (filtres.unite_production && this.unite_productions) {
        const up = this.unite_productions.find(u => u.id === filtres.unite_production);
        nomUp = up ? up.nom : '';
      }

      // Récupère le nom du groupement sélectionné
      if (filtres.groupement && this.groupements) {
        console.log('filtres.groupement', filtres.groupement);
        const group = this.groupements.find(g => g.id === filtres.groupement);
        nomGroupement = group ? group.nom : '';
      }

      // Récupère le nom du contrôleur sélectionné
      if (filtres.controleur && this.controleurs) {
        const controleur = this.controleurs.find(c => c.id === filtres.controleur);
        nomControleur = controleur ? controleur.nom : '';
      }
      // Fonction utilitaire pour nettoyer le nom (équivalent PHP)
      function genererNomFichierZip(nom) {
        if (!nom) {
          return '';
        }
        // Remplace les caractères accentués et spéciaux
        nom = nom.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        nom = nom.replace(/[^A-Za-z0-9]/g, '_');
        nom = nom.replace(/_+/g, '_');
        nom = nom.replace(/^_+|_+$/g, '');
        return nom.toLowerCase();
      }

      let filename = `fiches_${type}`;
      if (nomGroupement) {
        filename = `fiches_${type}_Group_${genererNomFichierZip(nomGroupement)}_${campagne}.zip`;
      } else if (nomUp) {
        filename = `fiches_${type}_UP_${genererNomFichierZip(nomUp)}_${campagne}.zip`;
      } else if (nomControleur) {
        filename = `fiches_${type}_Controleur_${genererNomFichierZip(nomControleur)}_${campagne}.zip`;
      } else if (campagne) {
        filename = `fiches_${type}_${campagne}.zip`;
      } else {
        filename = `fiches_${type}.zip`;
      }
      return filename;
    },
    async getControleurList() {
      const { data } = await controleurResource.list();
      this.controleurs = data;
    },
    async getVillagesList() {
      try {
        const { data } = await villageResource.list({ limit: 1000 });
        this.villages = data || [];
      } catch (error) {
        console.error('Erreur lors de la récupération des villages:', error);
        this.villages = [];
      }
    },
    async initSearch() {
      // Réinitialiser tous les filtres
      this.filters.contrats = { campagne: this.campagne_encours.id, scoop: '', region: '', zone: '', commune: '', village: '', unite_production: '', groupement: '' };
      this.filters.formations = { campagne: this.campagne_encours.id, controleur: '' };
      this.filters.controle_interne = { campagne: this.campagne_encours.id, region: '', zone: '', commune: '', village: '', unite_production: '', groupement: '', producteur: '' };
      this.filters.parcellaire = { campagne: this.campagne_encours.id, region: '', zone: '', commune: '', village: '', unite_production: '', groupement: '', producteur: '' };
      this.filters.bon_livraison = { campagne: this.campagne_encours.id, region: '', zone: '', commune: '', village: '', unite_production: '', groupement: '', producteur: '', controleur: '' };
      this.filters.collecte = { campagne: this.campagne_encours.id, region: '', zone: '', commune: '', village: '', unite_production: '', groupement: '', producteur: '', certification: '', dateRange: null };
      this.filters.multi = { campagne: this.campagne_encours.id, region: '', zone: '', commune: '', village: '', unite_production: '', groupement: '', producteur: '', controleur: '', certification: '', dateRange: null };
      this.multiTypes = ['contrats'];
      this.multiCountInfo = null;

      // Vider les listes
      this.zones = [];
      this.communes = [];
      this.villages = [];
      this.groupements = [];
      this.producteurs = [];

      // Recharger tous les champs
      await Promise.all([
        this.getRegionsList(),
        this.loadAllZonesAndCommunes(),
        this.getVillagesList(),
        this.getScoopsList(),
        this.getUniteProdList(),
        this.getCampagneList(),
        this.getControleurList(),
      ]);

      this.activeTab = 'contrats';
    },
  },
};
</script>
<style scoped>
.download-page {
  position: relative;
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.global-blocking-overlay {
  position: fixed;
  inset: 0;
  z-index: 3000;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
}

.global-blocking-overlay__content {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 18px 28px;
  border-radius: 999px;
  background: #ffffff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);
  color: #303133;
  font-weight: 600;
}

.download-card {
  border-radius: 12px;
  overflow: hidden;
}

.download-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.download-tabs {
  min-height: 420px;
}

.download-tabs :deep(.el-tabs__header) {
  margin-right: 24px;
}

.download-tabs :deep(.el-tabs__item) {
  font-size: 14px;
  padding-left: 20px;
}

.download-tabs :deep(.el-tabs__content) {
  padding: 24px 32px 32px 24px;
  overflow: visible;
}

.download-tab-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 320px;
}

.download-tab-spinner__oval {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 20px 48px;
  background: linear-gradient(135deg, #f5f7fa 0%, #eef1f6 100%);
  border-radius: 9999px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  font-size: 15px;
  color: #606266;
}

.download-pane {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.download-pane__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #ebeef5;
}

.download-pane__title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #303133;
}

.download-pane__filters {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.download-pane__filters-label {
  font-size: 13px;
  font-weight: 600;
  color: #606266;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.download-count-block--top {
  margin-bottom: 4px;
}

.download-form {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 24px;
  align-items: flex-start;
}

.download-form :deep(.el-form-item) {
  margin-bottom: 0;
}

.download-pane__actions {
  padding-top: 8px;
}

.download-count-badge {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 12px 20px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.download-count-badge i {
  font-size: 18px;
}

.download-count-badge--zero {
  background: #f4f4f5;
  color: #909399;
  border: 1px solid #e9e9eb;
}

.download-count-badge--over {
  background: #fdf6ec;
  color: #b88230;
  border: 1px solid #f5dab1;
}

.download-count-badge--ok {
  background: #f0f9eb;
  color: #529b2e;
  border: 1px solid #c2e7b0;
}

.download-multi-details {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.download-multi-details__item {
  background: #f4f6fa;
  border: 1px solid #e5e9f2;
  border-radius: 9999px;
  padding: 6px 10px;
  font-size: 12px;
  color: #606266;
}

.fiches-tabs {
  padding: 32px;
  color: #6b778c;
  font-size: 32px;
  font-weight: 600;
}

.download-count-block {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 12px 0 16px;
  min-height: 24px;
}

.download-count-block--loading {
  justify-content: center;
  min-height: 120px;
  margin: 24px 0;
}

.download-count-loading-oval {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 20px 48px;
  background: #f0f2f5;
  border-radius: 9999px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.download-count-loading-oval .count-text {
  font-size: 15px;
  color: #606266;
}

.download-count-block .count-text {
  font-size: 14px;
}

.download-count-block .count-zero {
  color: #909399;
}

.download-count-block .count-over {
  color: #e6a23c;
}

.download-count-block .count-ok {
  color: #67c23a;
}
</style>
